// queries and motations
import {
  CREATE_PIECEWORK,
  GET_ALL_WITH_PAGINATION,
  DELETE_PIECEWORK,
  GET_BY_ID,
  EXISTS,
  UPDATE_PIECEWORK
} from '@/graphql/piecework/piecework'

// models
import { PieceWorkGenerate, Piecework, FilterPiecework, PieceworkWithPagination } from '@/models/piecework'

// apollo
import { apolloClient } from '@/apollo'

class PieceworkService {
  /**
   * Query
   */
  async getAllWithPagination (perPage: number, page: number, filters: FilterPiecework): Promise<PieceworkWithPagination> {
    const result = await apolloClient.query({
      query: GET_ALL_WITH_PAGINATION,
      variables: {
        first: Number(perPage),
        page: Number(page),
        filters: {
          ...filters,
          headquarter: filters.headquarter ? Number(filters.headquarter) : null,
          type: Number(filters.type)
        }
      }
    })
    return {
      pagination: result.data.pieceworksWithPagination.paginatorInfo,
      objects: result.data.pieceworksWithPagination.data
    }
  }

  async getById (id: number): Promise<Piecework> {
    const result = await apolloClient.query({
      query: GET_BY_ID,
      variables: {
        id: Number(id)
      }
    })
    return result.data.piecework
  }

  async exists (date: string, headquarter: number, area: number, type: boolean): Promise<{ exists: boolean; id: number }> {
    const result = await apolloClient.query({
      query: EXISTS,
      variables: {
        date,
        headquarter,
        area,
        type
      }
    })
    return result.data.pieceworkExists
  }

  /**
   * Mutations
   */
  async create (input: PieceWorkGenerate): Promise<Piecework> {
    const result = await apolloClient.mutate({
      mutation: CREATE_PIECEWORK,
      variables: {
        input: input
      }
    })
    return result.data.createPiecework
  }

  async update (id: number, input: PieceWorkGenerate): Promise<Piecework> {
    const result = await apolloClient.mutate({
      mutation: UPDATE_PIECEWORK,
      variables: {
        id: Number(id),
        input: input
      }
    })
    return result.data.updatePiecework
  }

  async delete (id: number): Promise<Piecework> {
    const result = await apolloClient.mutate({
      mutation: DELETE_PIECEWORK,
      variables: {
        id: id
      }
    })
    return result.data.deletePiecework
  }
}

export default new PieceworkService()
